import dayjs from 'dayjs';
import { useCallback } from 'react';
import { useCurrentUserProfile } from 'src/graphql';
import useNavigationStore from 'src/store/navigation';

// accounts created from this date on never saw the old right-hand panel
const SIDEKICK_MOVED_ON = '2026-07-30';

export interface SidekickTransition {
  hasTransitioned: boolean;
  showTransitionBar: boolean;
  isMovedCueVisible: boolean;
  completeTransition: () => void;
  dismissMovedCue: () => void;
}

export const useSidekickTransition = (): SidekickTransition => {
  const storedTransitioned = useNavigationStore((state) => state.sidekickTransitioned);
  const isMovedCueVisible = useNavigationStore((state) => state.sidekickMovedCue);
  const setSidekickTransitioned = useNavigationStore((state) => state.setSidekickTransitioned);
  const setSidekickMovedCue = useNavigationStore((state) => state.setSidekickMovedCue);

  const { user } = useCurrentUserProfile();
  const userCreatedAt = user?.createdAt;

  const joinedAfterMove =
    Boolean(userCreatedAt) && !dayjs(userCreatedAt).isBefore(dayjs(SIDEKICK_MOVED_ON));
  const hasTransitioned = storedTransitioned || joinedAfterMove;

  const completeTransition = useCallback(() => {
    setSidekickTransitioned(true);
    setSidekickMovedCue(true);
  }, [setSidekickTransitioned, setSidekickMovedCue]);

  const dismissMovedCue = useCallback(() => setSidekickMovedCue(false), [setSidekickMovedCue]);

  return {
    hasTransitioned,
    // held back until the profile loads, so it never flashes at new accounts
    showTransitionBar: !hasTransitioned && Boolean(userCreatedAt),
    isMovedCueVisible,
    completeTransition,
    dismissMovedCue,
  };
};
